import * as a from "react";
import s from "../lib/IconBase.es.js";
import t from "../defs/CalendarPlus.es.js";
const e = a.forwardRef((o, r) => /* @__PURE__ */ a.createElement(s, { ref: r, ...o, weights: t }));
e.displayName = "CalendarPlusIcon";
const m = e;
export {
  m as CalendarPlus,
  e as CalendarPlusIcon
};
